export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["有争议的列"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["重置"])}
}